/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface Open360BusinessLogicInventoryModelsOperationStatistics {
    ID?: string;
    RetailerID?: number;
    ClientID?: string;
    RequestTimeStamp?: Date;
    Duration?: string;
    /**
     * 1 = API, 2 = CSV
     */
    Source?: Open360BusinessLogicInventoryModelsOperationStatistics.SourceEnum;
    /**
     * 0 = FullUpdate, 1 = PriceUpdate, 2 = VariationArchive, 3 = FullUpdateReplace
     */
    Kind?: Open360BusinessLogicInventoryModelsOperationStatistics.KindEnum;
    /**
     * 1 = Enqueued, 2 = Processing, 3 = Processed
     */
    Status?: Open360BusinessLogicInventoryModelsOperationStatistics.StatusEnum;
    /**
     * 1 = None, 2 = Success, 3 = Warning, 4 = Error
     */
    Result?: Open360BusinessLogicInventoryModelsOperationStatistics.ResultEnum;
    ItemsCount?: number;
    ItemsUpdatedCount?: number;
    ItemsAddedCount?: number;
    ErrorsCount?: number;
    ConflictsCount?: number;
}
export namespace Open360BusinessLogicInventoryModelsOperationStatistics {
    export type SourceEnum = 1 | 2;
    export const SourceEnum = {
        NUMBER_1: 1 as SourceEnum,
        NUMBER_2: 2 as SourceEnum
    }
    export type KindEnum = 0 | 1 | 2 | 3;
    export const KindEnum = {
        NUMBER_0: 0 as KindEnum,
        NUMBER_1: 1 as KindEnum,
        NUMBER_2: 2 as KindEnum,
        NUMBER_3: 3 as KindEnum
    }
    export type StatusEnum = 1 | 2 | 3;
    export const StatusEnum = {
        NUMBER_1: 1 as StatusEnum,
        NUMBER_2: 2 as StatusEnum,
        NUMBER_3: 3 as StatusEnum
    }
    export type ResultEnum = 1 | 2 | 3 | 4;
    export const ResultEnum = {
        NUMBER_1: 1 as ResultEnum,
        NUMBER_2: 2 as ResultEnum,
        NUMBER_3: 3 as ResultEnum,
        NUMBER_4: 4 as ResultEnum
    }
}



// WEBPACK FOOTER //
// ./src/app.retailer/modules/model/open360BusinessLogicInventoryModelsOperationStatistics.ts